
export const styles = theme => ({
  check: {
    margin: 1
  }
});
